<template>
	<div id="wjstate" class="wjstate">
		<div style="width: 100%; height: 100%;">
			<div class="leftNav">
				<div class="wjTypeChild" :style="{ height: height + 'px' }" style="overflow-y: hidden">
					<div v-for="(item) in navList" :key="item.id">
						<div
							style="text-align: center"
							class="wjTypeChildItemFont"
							:class="{
								wjTypeChildItem: item.id != 0,
								iconActive: sendType == item.id
							}"
							
						>
							<div class="icon"  @click="selectIcon(item.id)" v-show="item.show">
								<img :src="item.icon2" v-if="sendType == item.id"   />
								<img :src="item.icon" v-else  />
							</div>
							<span  @click="selectIcon(item.id)" v-show="item.show">{{ item.label }}</span>
						</div>
					</div>
				</div>
			</div>
			<!-- <router-view style="padding-left: 80px;"></router-view> -->
			<div class="content-box">
				<!-- 发布 -->
				<div class="unpublished" v-if="examState == 1">
					<div style="text-align: center">
						<el-button type="primary" @click="publishwj()">开始发布</el-button>
					</div>
					<div style="text-align: center; margin-top: 20px">
						开启发布后，即可分享问卷
					</div>
				</div>
				<div v-show="examState == 2 && permissionList.admin1020" class="share-box">
					<!-- 链接分享 -->
					<div v-if="sendType == 0" class=" link-box">
						<!-- 分享链接/二维码 -->
						<div class="box-card">
							<p class="share_project">
								项目分享
								<span>(项目发布后，链接与二维码始终不变)</span>
							</p>
							<div class="share-contont">
								<div class="fl_link">
									<p>分享链接</p>
									<div class="link_line-box">
										<p class="link_line">
											<el-input id="copyurl" :disabled="true" placeholder="请输入内容" v-model="share.address">
												<el-button slot="append" v-clipboard:copy="share.address" @click="copyUrl()" >复制</el-button>
											</el-input>
											
										</p>
										<el-button class="btn" type="primary" @click="openwj()" size="medium">打开</el-button>
									</div>
									
									<!-- <div class="answer-square">
										<el-button class="">发布到答题广场</el-button>
									</div> -->
								</div>
								<div class="qrCode" style="">
									<canvas ref="qrCodeImg" class="qrCode-img"></canvas>
									<p
										style="font-size: 12px; margin-left: 18px; color: #0080ff;cursor: pointer;"
										@click="qrCodeUpload()"
									>
										下载二维码
									</p>
								</div>
							</div>
						</div>
						<!-- 微信分享 -->
						<div class="box-card">
							<p class="wx_share">微信分享</p>
							<div class="wx_content">
								<div class="upload_explain" >
								<div>
									<p
									style="
										font-family: MicrosoftYaHei;
										font-size: 14px;
										color: #333333;
									"
									>
									上传Logo
									</p>
									<div style="display: flex; margin-top: 14px">
									<img
										:src="wxsharePicture"
										v-if="logo"
										alt="分享logo"
										style="width: 40px; height: 40px"
									/>
									<img
										:src="uploadSuces"
										v-if="logoSucc"
										alt="分享logo"
										style="width: 40px; height: 40px"
									/>
									<div style="margin-left: 20px">
										<el-upload
											class="avatar-uploader"
											:action="$config.service.uploadApi"
											:show-file-list="false"
											:on-success="handleSuccess"
											:before-upload="beforeAvatarUpload"
											:data="QiniuData"
											:on-remove="handleRemove"
											multiple
											:limit="1"
										>
										<!-- v-if="btnUpload"
										> -->
										<el-button size="small" style="color: #0080ff"
											>点击上传</el-button
										>
										</el-upload>
										<!-- <button
										v-if="btnDel"
										@click="delImg()"
										class="btnDel"
										style="
											width: 88px;
											height: 34px;
											background: #fff;
											border-radius: 3px;
											border: 1px solid #ccc;
											color: #0080ff;
										"
										>
										点击删除
										</button> -->
										<p
										style="
											font-family: MicrosoftYaHei;
											font-size: 12px;
											color: #666;
											margin-top: 17px;
										"
										>
										图片支持png、jpg格式,建议尺寸100*100
										</p>
									</div>
									</div>
								</div>
								<div class="WXSharetitle">
									<p class="share_description">分享标题</p>
									<el-input
									v-model="wxshareTitle"
									placeholder="请输入内容"
									style="margin-top: 14px"
									@change="shareTitle"
									></el-input>
								</div>
								<div>
									<p class="share_description">分享描述说明</p>
									<el-input
									type="textarea"
									:rows="6"
									resize="none"
									placeholder="请输入内容"
									v-model="wxshareContent"
									style="margin-top: 14px;
									
									"
									@change="shareDesc"
									></el-input>
								</div>
								</div>
								<div class="upload_preview">
								<div style="width:325px;borderL1px solid blue">
									<p
									style="
										font-family: MicrosoftYaHei;
										color: #000;
										margin-top: 22px;
										font-size: 12px;
									"
									>
									好友分享预览
									</p>
									<div>
									<div class="send">
										<div class="arrow"></div>
										<div class="arrow_content_box" style="overflow: hidden">
										<div class="arrow_text_part">
											<p>{{ wxshareTitle }}</p>
											<span class="wjInfo_content" style="">{{
											wxshareContent
											}}</span>
										</div>
										<img
											:src="wxsharePicture"
											v-if="logo"
											class="wjInfo_img"
											style="width: 40px; height: 40px"
											alt=""
										/>
										<img
											:src="uploadSuces"
											v-if="logoSucc"
											class="wjInfo_img"
											style="width: 40px; height: 40px"
											alt=""
										/>
										</div>
									</div>
									<div style="clear: both"></div>
									<img
										src="@/assets/pic_head.png"
										style="float: right; margin-top: -100px"
										alt=""
									/>
									</div>
									<p
									style="font-size: 12px; margin-top: 49px; margin-bottom: 16px"
									>
									分享朋友圈预览
									</p>
									<div
									style="
										width: 286px;
										height: 32px;
										display: flex;
										align-items: center;
									"
									>
									<img src="@/assets/pic_head.png" alt="微信头像" />
									<span
										style="font-size: 14px; margin-left: 8px; overflow: hidden"
										>微信昵称</span
									>
									</div>
									<div
									style="
										width: 286px;
										height: 58px;
										background: #ebebeboverflow:hidden;
										margin-left: 35px;
										display: flex;
										align-items: center;
										background-color:#ffffff;
										border: 1px solid #d8d8d8;
										border-radius: 2px;
										"
									>
									<img
										:src="wxsharePicture"
										v-if="logo"
										style="margin-left: 5px; width: 40px; height: 40px"
										alt=""
									/>
									<img
										:src="uploadSuces"
										v-if="logoSucc"
										style="margin-left: 5px; height: 40px; width: 40px"
										alt=""
									/>
									<span
										style="font-size: 14px; margin-left: 10px; overflow: hidden"
										>{{ wxshareTitle }}</span
									>
									</div>
								</div>
								</div>
							</div>
							</div>
					</div>
					<!-- 短信分享 -->
					<div v-else-if="sendType == 1">
						<div class="message_share">
							<div class="message_title">
								<span class="message_text">短信分享</span>
								<span class="view_share" style=" cursor: pointer;" @click="viewShareMessage()"
								>查看已发送短信</span
								>
							</div>
							<div class="stepsbg">
								<el-steps
								:active="active"
								style="width: 920px; margin-left: 40px; padding-top: 35px"
								>
								<el-step title="添加收件人"></el-step>
								<el-step title="编辑内容"></el-step>
								<el-step title="提交审核"></el-step>
								</el-steps>
								<div v-if="active == 0" style="width: 920px; margin: 0 auto">
								<p class="brief_introduction">
									您可以从左侧联系人列表中添加，或手动输入'手机号,姓名'，每行代表一个联系人，姓名可以出现在短信正文中。例如：136xxxxxxxx,宋先生
								</p>
								<div class="Contact_table">
									<div class="contact_list">
									<div class="setContact">
										<span>联系人列表</span>
										<i class="el-icon-setting" @click="setContact()"></i>
									</div>
									<div class="searchInput">
										<el-input
										placeholder="请输入内容"
										prefix-icon="el-icon-search"
										v-model="input2"
										@input="searchInput()"
										></el-input>
									</div>
									<div class="treeBox" v-if="input2.length == 0">
										<el-tree :data="options1" :props="props">
										<span
											class="custom-tree-node"
											slot-scope="{ data }"
										>
											<span>
											<i class="el-icon-plus" @click="addright(data)"></i>
											{{ data.name }}
											<span v-if="data.contacts">{{
												"(" + data.contacts.length + ")"
											}}</span>
											</span>
										</span>
										</el-tree>
									</div>
									<div
										v-show="input2.length > 0"
										v-for="(item, index) in searchTell"
										:key="index"
										class="treeBox2"
									>
										{{ item.name }}
										<a
										class="right treeBox2_a"
										href="javascript:void(0)"
										@click="treeBox2_a(index)"
										>添加</a
										>
									</div>
									</div>
									<div class="Manually_enter_contacts">
									<div class="delContact">
										<span>手动输入联系人</span>
										<i class="el-icon-delete" @click="delContact()"></i>
									</div>
									<!--短信联系人-->
									<div
										id="MailCon_lxr"
										v-for="(item, index) in array"
										:key="index"
										style="
										margin-left: 10px;
										margin-top: 10px;
										color: #666;
										font-size: 14px;
										"
										:class="item.text_error ? '' : 'text_error'"
									>
										<span>
										{{ item.cellphone }} &nbsp;, &nbsp;{{ item.name }}
										<i
											class="el-icon-delete right"
											style="margin-right: 15px; color: #0080ff"
											@click="delMailConlxr(index)"
										></i>
										</span>
									</div>
									<div
										id="MailCon_srk"
										class="MailCon_srk"
										contenteditable="ture"
										@keyup.enter="addMailCon()"
									></div>
									</div>
								</div>
								<div style="width: 646px; margin-left: 273px; height: 94px">
									<div
									style="
										margin-top: 30px;
										display: flex;
										justify-content: space-between;
									"
									>
									<span v-if="lenth > 0">收件人数 : {{ lenth }}</span>
									<span v-else>收件人数 : 0</span>
									<div class="sendSelect" style="display: inline-block">
										<el-checkbox
										style="margin-right: 10px"
										v-model="checked"
										@change="ifSelected"
										>保存到</el-checkbox
										>
										<el-select
										v-model="label"
										placeholder="请选择"
										@change="saveGroup(label)"
										size="small"
										>
										<el-option
											v-for="item in options1"
											:key="item.id"
											:label="item.name"
											:value="item.name"
										></el-option>
										</el-select>
									</div>
									<el-button
										style="display: inline-block"
										type="primary"
										@click="xiaPart()"
										>下一步</el-button
									>
									</div>
								</div>
								</div>
								<!-- 编辑内容 -->
								<div v-if="active == 1" style="width: 920px; margin: 0 auto">
								<div class="surveylink">
									使用须知：
									<br />
									1.您发送的短信需要经过内容审核
									<br />
									2.短信抬头将显示为【东方艾学代发】
									<br />
									3.发送成功后，可以查看已发短信的进度
									<br />
									4.$[name]表示联系人姓名 $[surveylink]表示问卷地址
									<br />
									5.给异常的手机号（包括停机，空号等）发送短信，也会扣除短信余额或账户余额
								</div>
								<!-- <div class="sendContent">
									{{ sub.smsContent }}
								</div> -->
								<el-input
									type="textarea"
									placeholder="请输入内容"
									v-model="sub.smsContent"
									:show-word-limit="true"
									rows="10"
								>
								</el-input>

								<div class="success_btn">
									<span></span>
									<div>
									<button
										style="
										border: 1px solid #ccc;
										background: #fff;
										margin-right: 20px;
										"
										@click="backSteps()"
									>
										上一步
									</button>
									<button
										style="background: #0080ff; color: #fff"
										@click="achieve()"
									>
										发送
									</button>
									</div>
								</div>
								</div>
								<div v-if="active == 2" style="width: 920px; margin: 0 auto">
								<div class="accomplishPage">
									<div class="accomploshText" style="margin-top: 50px">
									<p style="font-size: 14px">
										为了防范恶意垃圾短信，您的短信需要通过审核后才能发送。
									</p>
									<br />
									<p>我们将通过【系统消息】告知您审核进度和结果。</p>
									</div>
									<br />
									<div><button @click="accomplish()">完成</button></div>
								</div>
								</div>
							</div>
							</div>
					</div>
					<!-- 邮件分享 -->
					<div v-else-if="sendType == 2">
						<div class="message_share">
							<div class="message_title">
								<span class="message_text">邮件分享</span>
								<span class="view_share" style=" cursor: pointer;" @click="viewShareEmail()"
								>查看已分享邮件</span
								>
							</div>
							<div class="stepsbg">
								<el-steps
								:active="ativeStep"
								align-center
								style="padding-top: 35px"
								>
								<el-step title="添加收件人"></el-step>
								<el-step title="编辑内容"></el-step>
								<el-step title="选择发送方式"></el-step>
								<el-step title="提交审核"></el-step>
								</el-steps>
								<!-- 添加收件人 -->
								<div
								v-if="ativeStep == 0"
								style="width: 920px; margin: 0 auto; padding-top: 30px"
								>
								<p
									style="
									font-family: MicrosoftYaHei;
									font-size: 14px;
									font-weight: normal;
									font-stretch: normal;
									line-height: 28px;
									letter-spacing: 0px;
									color: #666666;
									"
								>
									您可以从左侧“通讯录”中批量添加，或在右侧手动输入收件人邮箱（或“邮箱,姓名”）。每次最多添加500个。
								</p>
								<div class="Contact_table" style="margin-top: 20px">
									<div class="contact_list">
									<div class="setContact" @click="setContact()">
										<span>联系人列表</span>
										<i class="el-icon-setting"></i>
									</div>
									<!--搜索框-->
									<div class="searchInput">
										<el-input
										placeholder="请输入内容"
										prefix-icon="el-icon-search"
										v-model="input2"
										@input="searchInput2()"
										></el-input>
									</div>
									<!--添加列表-->
									<div
										v-show="input2.length > 0"
										v-for="(item, index) in searchTell"
										:key="index"
										class="treeBox2"
									>
										{{ item.name }}
										<a
										class="right treeBox2_a"
										href="javascript:void(0)"
										@click="treeBox2_b(index)"
										>添加</a
										>
									</div>
									<!-- 联系人列表 -->
									<div class="treeBox" v-if="input2.length == 0">
										<el-tree :data="options1" :props="props">
										<span
											class="custom-tree-node"
											slot-scope="{  data }"
										>
											<span>
											<i class="el-icon-plus" @click="addEmail(data)"></i>
											{{ data.name }}
											<span v-if="data.contacts">{{
												"(" + data.contacts.length + ")"
											}}</span>
											</span>
										</span>
										</el-tree>
									</div>
									</div>
									<div class="Manually_enter_contacts">
									<div class="delContact">
										<span>手动输入联系人</span>
										<i class="el-icon-delete" @click="delEmailContact()"></i>
									</div>

									<!--邮件联系人添加处-->
									<div
										v-for="(item, index) in arrEmail"
										:key="index"
										style="
										margin-left: 10px;
										margin-top: 10px;
										color: #666;
										font-size: 14px;
										"
										:class="item.Email_error ? '' : 'Email_error'"
									>
										<span>
										{{ item.email }} &nbsp;, &nbsp;{{ item.name }}
										<i
											class="el-icon-delete right"
											style="margin-right: 15px; color: #0080ff"
											@click="delEmailConlxr(index)"
										></i>
										</span>
									</div>
									<div
										id="emailContact"
										class="emailContact"
										contenteditable="ture"
										@keyup.enter="addemailContacts()"
									></div>
									</div>
								</div>
								<div style="width: 646px; margin-left: 273px; height: 94px">
									<div
									style="
										width: 646px;
										height: 40px;
										margin-top: 20px;
										display: flex;
										align-items: center;
									"
									>
									<span v-if="lenEmail > 0">收件人数 : {{ lenEmail }}</span>
									<span v-else>收件人数 : 0</span>
									<div
										class="sendSelect"
										style="margin-left: 160px; margin-right: 40px"
									>
										<el-checkbox
										v-model="checked"
										@change="ifSelected"
										style="margin-right: 10px"
										>保存到</el-checkbox
										>
										<el-select
										v-model="labelEm"
										placeholder="请选择"
										@change="saveGroup(label)"
										size="small"
										>
										<el-option
											v-for="item in options1"
											:key="item.id"
											:label="item.name"
											:value="item.name"
										></el-option>
										</el-select>
									</div>
									<el-button type="primary" @click="nextStept()"
										>下一步</el-button
									>
									</div>
								</div>
								</div>
								<!-- 编辑内容 -->
								<div
								v-if="ativeStep == 1"
								style="width: 920px; margin: 0 auto; padding-top: 30px"
								>
								<p
									style="
									font-family: MicrosoftYaHei;
									font-size: 14px;
									font-weight: normal;
									font-stretch: normal;
									letter-spacing: 0px;
									color: #666666;
									"
								>
									使用说明：“$[name]”表示收件人姓名，“$[surveylink]”表示测评地址
								</p>
								<div>
									<p style="margin-top: 19px">
									<span>发件人</span>
									<input
										type="text"
										v-model="mail_recipient"
										style="
										margin-left: 10px;
										width: 200px;
										height: 36px;
										color: #666;
										text-indent: 5px;
										"
									/>
									<span style="margin-left: 78px">发件人邮箱</span>
									<input
										type="text"
										v-model="sender_email"
										style="
										margin-left: 10px;
										width: 470px;
										height: 36px;
										color: #666;
										text-indent: 5px;
										"
									/>
									</p>
									<p style="margin-top: 19px; margin-bottom: 14px">
									<span>主题</span>
									<input
										type="text"
										v-model="theme"
										style="width: 854px; height: 36px; margin-left: 20px"
									/>
									</p>
								</div>
								<div><vue-tinymce v-model="contentt" :setting="setting" /></div>
								<div style="margin-left: 742px; margin-top: 10px; height: 54px">
									<el-button type="primary" @click="lastStep()">上一步</el-button>
									<el-button type="primary" @click="emailNextStept()">下一步</el-button>
								</div>
								</div>
								<!-- 选择发送方式 -->
								<div
								v-if="ativeStep == 2"
								style="
									width: 930px;
									height: auto;
									margin: 0 auto;
									padding-top: 30px;
								"
								>
								<div
									style="
									width: 930px;
									height: 400px;
									display: flex;
									justify-content: space-around;
									"
								>
									<div
									class="emali_fs"
									style="border: 1px solid #0080ff; width: 450px; height: 320px"
									>
									<div
										style="
										width: 100%;
										height: 170px;
										background: url('data:image/png;base64,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');
										background-repeat: no-repeat;
										background-position: center center;
										text-align: center;
										line-height: 300px;
										"
									>
										使用神采问卷邮箱发送
									</div>
									<p>
										统一显示神采问卷的发件邮箱地址:ai@almail.ai-learning.com.cn
									</p>
									<p>每封邮件消耗一条邮件余额,邮件余额需充值购买。</p>
									<p>
										邮件剩余: <span>{{ emailBalance }}</span> 封
										<!-- <a href="javascript:void(0);">充值购买</a> -->
										<router-link
										to="/emailRecharge"
										target="_blank"
										style="color: #2672ff"
										>充值购买</router-link
										>
									</p>
									</div>
									<div
									class="emali_fs"
									style="border: 1px solid green; width: 450px; height: 320px"
									>
									<div
										style="
										width: 100%;
										height: 170px;
										background: url('data:image/png;base64,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');
										background-repeat: no-repeat;
										background-position: center center;
										text-align: center;
										line-height: 300px;
										"
									>
										使用自有邮箱发送
									</div>
									<p>
										需绑定个人邮箱或企业邮箱,显示您的发件邮箱地址,提升品牌形象,不消耗邮件余额,发送成功率更可靠。
									</p>
									<p style="margin-top: 20px">
										限高级版使用
										<a href="javascript:void(0);" style="padding-left: 10px"
										>立即升级
										<span style="color: #aaa">( 暂未开放)</span>
										</a>
									</p>
									</div>
								</div>
								<div style="margin-left: 742px; margin-top: 10px; height: 54px">
									<el-button type="primary" @click="lastStep()">上一步</el-button>
									<el-button type="primary" @click="sendEmails()">发送</el-button>
								</div>
								</div>
								<!-- 提交审核 -->
								<div
								v-if="ativeStep == 3"
								style="width: 920px; margin: 0 auto; padding-top: 30px"
								>
								<p class="justifyCenter">
									为了防范恶意垃圾邮件，您的邮件需要通过审核后才能发送
								</p>
								<p class="justifyCenter">
									我们将通过【系统消息】告知您审核进度和结果。
								</p>
								<button class="emaileAuccess" @click="accomplishEmail()">
									完成
								</button>
								</div>
							</div>
							</div>
					</div>
				</div>
				<!-- 设置 -->
				<div v-show="examState == 2 && sendType == 3" >
					<div class="wjTypeChildQuestion">
						<div class="tk_item" style="height: 0px !important"></div>
						<div
							class="tk_item"
							v-for="(szType, index) in szTypeList"
							:key="index"
							@click="goAnchor(szType.name)"
						>
						<div class="display_inline" style="width: 5%"></div>

						<div
							class="display_inline"
							style="width: 65%; font-size: 16px; color: gray"
						>
							<span>{{ szType.title }}</span>
						</div>
						<div class="display_inline" style="width: 25%; text-align: right">
							<img src="@/assets/tk/jt_def_icon.png" />
						</div>
						</div>
						
					</div>
					<div class="setUp-box">
						<ExamTypeSetting ref="getSetting" @getWXshare="getWXshare" @getExamState="getExamState" :showBtn="0"></ExamTypeSetting>
					</div>
				</div>
			</div>
		</div>
		<!--短信发送确认模态框-->
    	<div v-if="sendMask" class="sendMask"></div>
		<div class="sendData" v-if="sendMask">
			<h3>
				发送确认
				<i class="el-icon-close" @click="clockSendMask"></i>
			</h3>
			<div style="width: 550px; margin: auto">
				<div style="height: 90px">
				<h5 style="font-size: 16px; color: #666">短信内容</h5>
				<div style="padding: 5px; background: #fafafa">
					{{ sub.smsContent }}
				</div>
				</div>
				<div style="height: 30px; margin-top: 40px; color: #898989">
				内容包含 &nbsp;{{ sub.wordLength }}&nbsp;个字符, 将消费{{
					sub.number
				}}条短信余额
				</div>
				<p style="height: 30px; color: #ff3737; margin-bottom: 20px">
				本条短信将发送给{{ sub.smsNumber }}位联系人,总共消费{{
					sub.number
				}}条短信余额
				</p>
				<p class="left" style="">
				短信余额:
				<span>{{ smsBalance }}</span>
				条 &nbsp;
				<router-link
					to="/messageRecharge"
					target="_blank"
					style="color: #2672ff"
					>充值</router-link
				>
				</p>
				<div class="sendMask_btn right">
				<el-button @click="clockSendMask">返回修改</el-button>
				<el-button @click="sendMask_send">发送</el-button>
				</div>
			</div>
		</div>
		<!-- 查看已发送短信   返回-->
		<el-dialog width="80%" title="已发送短信" :visible.sync="viewShare" :close-on-click-modal="false">
			<el-button @click="viewDetail = true">详情（操作）</el-button>
			<el-table
				:data="beensent"
				border
				style="
					margin: auto;
					margin-top: 10px;
					background: #f5f5f5;
				"
				>
				<el-table-column
					prop="smsContent"
					label="短信内容"
					width="300"
					align="center"
				></el-table-column>
				<el-table-column
					prop="smsNumber"
					label="发送人数"
					width="180"
					align="center"
				></el-table-column>
				<el-table-column
					prop="sendTime"
					label="发送时间"
					align="center"
				></el-table-column>
				<el-table-column prop="smsState" label="状态" align="center">
					<template slot-scope="scope">
					<span v-if="scope.row.smsState == 1">短信已投递</span>
					<span v-else-if="scope.row.smsState == 2">短信未投递</span>
					<span v-else>短信投递失败</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="auditReasons"
					label="原因"
					align="center"
				></el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
					<el-button
						type="text"
						@click="seeDetail(scope.row,1,10)"
						style="color: #0080ff"
						>查看详情</el-button
					>
					<!-- <span @click="seeDetail(scope.row)" style="color: #0080ff"
						>查看详情</span
					> -->
					</template>
				</el-table-column>
			</el-table>
			<el-dialog
				width="70%"
				title="已发送短信详情"
				:visible.sync="viewDetail"
				append-to-body :close-on-click-modal="false">
					<el-table
					:data="SmsContacts"
					style="margin: auto; margin-top: 10px"
					>
					<el-table-column
						prop="cellphone"
						label="手机号码"
						width="300"
						align="center"
					></el-table-column>
					<el-table-column
						prop="name"
						label="姓名"
						width="180"
						align="center"
					></el-table-column>
					<el-table-column prop="result" label="状态" align="center">
						<template slot-scope="scope">
						<span v-if="scope.row.result == 1">成功</span>
						<span v-else>失败</span>
						</template>
					</el-table-column>
					<el-table-column prop="cause" label="原因" align="center">
						<template slot-scope="scope">
						<span>{{ scope.row.cause }}</span>
						</template>
					</el-table-column>
					</el-table>
					<!-- 表格分页 -->
					<div style="padding: 10px; text-align: center">
					<el-pagination
						@current-change="currentChange"
						:hide-on-single-page="page_value"
						:current-page.sync="one_page.currentPageIndex"
						:page-size="one_page.pageSize"
						:total="one_page.totals"
						class="fr"
						background
						layout="prev, pager, next, jumper"
					></el-pagination>
					</div>
			</el-dialog>
		</el-dialog>
		<!-- 查看已发送邮件 -->
		<el-dialog width="80%" title="已发送短信" :visible.sync="viewEmail" :close-on-click-modal="false">
			<el-button @click="viewEmailDetail = true">详情（操作）</el-button>
			<el-table
			:data="Messagesent"
			border
			style="background: #f5f5f5; margin: 10px auto auto"
			>
			<el-table-column
				prop="emailContent"
				label="邮件主题"
				width="300"
				align="center"
			></el-table-column>
			<el-table-column
				prop="emailNumber"
				label="收件人数"
				width="180"
				align="center"
			></el-table-column>
			<el-table-column
				prop="sendState"
				label="发送方式"
				width="180"
				align="center"
			>
			<template slot-scope="scope">
				<span v-if="scope.row.sendState ==0">使用神采问卷邮箱发送</span>
				<span v-else>使用自有邮箱发送</span>
			</template>
			</el-table-column>
			<el-table-column
				prop="sendTime"
				label="发送时间"
				align="center"
			></el-table-column>
			<el-table-column
				prop="state"
				label="状态"
				align="center"
			>
			<template slot-scope="scope">
				<span v-if="scope.row.state == 1">未投递</span>
				<span v-else-if="scope.row.state == 2">已投递</span>
				<span v-else-if="scope.row.state == 3">投递失败</span>
			</template>
			</el-table-column>
			<el-table-column
				prop="auditReasons"
				label="原因"
				align="center"
			></el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
				<el-button type="text"  @click="seeDetailEmail(scope.row,1,10)" style="color: #0080ff">查看详情</el-button>
				</template>
			</el-table-column>
			</el-table>
			<el-dialog
				width="70%"
				title="已发送短信详情"
				:visible.sync="viewEmailDetail"
				append-to-body :close-on-click-modal="false">
					<el-table
				:data="emailDetailsData"
				style="margin: auto; margin-top: 10px"
				>
				<el-table-column
					prop="email"
					label="邮箱"
					width="300"
					align="center"
				>
					<template slot-scope="scope">
					<span v-if="scope.row.email">{{scope.row.name}}</span>
					<span v-else>暂无</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="name"
					label="姓名"
					width="180"
					align="center"
				>
					<template slot-scope="scope">
					<span v-if="scope.row.name">{{scope.row.name}}</span>
					<span v-else>暂无</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="sendTime"
					label="发送时间"
					width="180"
					align="center"
				>
					<template slot-scope="scope">
					<span >{{scope.row.sendTime}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="result" label="状态" align="center">
					<template slot-scope="scope">
					<span v-if="scope.row.result == 1">成功</span>
					<span v-else>失败</span>
					</template>
				</el-table-column>
				<el-table-column prop="cause" label="原因" align="center">
					<template slot-scope="scope">
					<span>{{ scope.row.cause }}</span>
					</template>
				</el-table-column>
				</el-table>
				<!-- 表格分页 -->
				<div style="padding: 10px; text-align: center">
					<el-pagination
						@current-change="emailCurrentChange"
						:hide-on-single-page="page_value"
						:current-page.sync="one_page.currentPageIndex"
						:page-size="one_page.pageSize"
						:total="one_page.totals"
						class="fr"
						background
						layout="prev, pager, next, jumper"
					></el-pagination>
				</div>
			</el-dialog>
		</el-dialog>
	  
	</div>
</template>

<script>
import ExamTypeSetting from "./components/examTypeSetting.vue"
import QrCode from 'qrcode'
import qs from 'qs'
import { mapState } from "vuex"
export default {
	components: {
		ExamTypeSetting,
	},
	data() {
		return {
			permissionList:{},
			id: '',
			height: 0,
			title: '',
			navList: [
				{
					id: "0",
					label: "分享链接",
					icon: require("@/assets/tx/lianjie.png"),
					icon2: require("@/assets/tx/lianjie1.png"),
                    path: "/sendTest",
					show:true,
				},
				// {
				// 	id: "1",
				// 	label: "短信分享",
				// 	icon: require("@/assets/tx/shouji.png"),
				// 	icon2: require("@/assets/tx/shouji1.png"),
                //     path: "",
				// },
				// {
				// 	id: "2",
				// 	label: "邮件分享",
				// 	icon: require("@/assets/tx/youjian.png"),
				// 	icon2: require("@/assets/tx/youjian1.png"),
                //     path: "",
				// },
				{
					id: "3",
					label: "设置",
					icon: require("@/assets/tx/tab_def_icon5.png"),
					icon2: require("@/assets/tx/tab_sel_icon5.png"),
					path: "",
						show:true,
				},
			],
			examState: 1,
			sendType: 0,
			share: {
				address: ``
			},
			redpacketpacket:false,
			dialogVisible: false,
			dialogWJVisible:false,
			next: null,
			smsBalance: "", // 短信余额
			emailBalance: "",
			sendMask: false, //遮罩层和发送确认
			loading: null,
			text_error: true,
			Email_error: true,
			sender_email: "如：ai@almail.ai-learning.com.cn",
			theme: "",
			mail_recipient: "如：东方艾学",
			contentt: `你好，
					我刚刚通过东方神采制作了一份测评，“复制-示例问卷”麻烦你抽空填写一下，多谢啦。 

					$[surveylink]`,
			setting: {
				menubar: false,
				toolbar:
				"undo redo | fullscreen | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | image media table | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat |",
				toolbar_drawer: "sliding",
				quickbars_selection_toolbar:
				"removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
				plugins: "link image media table lists fullscreen quickbars",
				language: "zh_CN",
				height: 350,
			},
			labelEm: "",
			inputEmail: "",
			ativeStep: 0,
			array: [], //电话联系人
			arrayEmail: [], //邮件联系人
			searchTell: [], //输入查找的电话
			checked: "",
			wxshareTitle: "", // 微信分享标题
			wxshareContent: "", // 微信分享描述
			wxsharePicture: "", // 微信分享logo
			label: "",
			props: {
				label: "name",
				children: "contacts",
			},
			options1: [],
			options2: [],
			input2: "",
			active: 0,
			activephone: 0,
			publicPage: true,
			messageShare: false,
			activeName: "first",
			input: "神采问卷课调查",
			logoImg: require("@/assets/tx/logo_share.png"),
			display: "none",
			left: 0,
			top: 0,
			curWjInfo: {},
			questionlist: [],
			selectIndex: 0,
			selectTypeIndex: 0,
			isCollapse: true,
			activeNames: [0, 1, 2],
			asklist: [],
			qtypes: ["题目控件", "我的题库"],
			qtypeval: "题目控件",
			rightheight: 0,
			activeIndex: "0",
			editIndex: -1,
			editOptionIndex: "0_0",
			wjTypeList: [],
			typeIndex: -1,
			centerDialogVisible: false,
			tkList: [],
			curTkType: {},
			curSzType: {},
			searchQuestionsName: "",
			showSzDialog: false,
			Channels_share_id: "",
			selectId: 0,
			Channels_share: [
				{
				id: "0",
				label: "分享链接",
				icon: require("@/assets/tx/lianjie.png"),
				icon2: require("@/assets/tx/lianjie1.png"),
				},
				{
				id: "1",
				label: "短信分享",
				icon: require("@/assets/tx/shouji.png"),
				icon2: require("@/assets/tx/shouji1.png"),
				}, 
				{
				id: "2",
				label: "邮件分享",
				icon: require("@/assets/tx/youjian.png"),
				icon2: require("@/assets/tx/youjian1.png"),
				},
			],
			Messagesent: [],
			QiniuData: {
				biz: 'upDataKs',
				data: {}
			},
			uploadPicUrl: "", //提交到后台图片地址
			uploadSuces: "",
			logo: true,
			logoSucc: false,
			btnUpload: true,
			btnDel: false,
			content: "",
			arr11: [],
			len: "",
			lenth: "",
			ifSel: 0,
			sub: {
				smsContent:'你好，我刚刚通过东方神采制作了一份测评，“复制-示例问卷”麻烦你抽空填写一下，多谢啦。 $[surveylink]'
			},
			inputname: "",
			emailShare: false,
			arrEmail: [],
			lenEmail: "",
			viewShare: false,
			beensent: [],
			viewDetail: false,
			SmsContacts: [],
			emailDetailsData: [],
			viewEmail: false,
			viewEmailDetail: false,
			sendEmailContent: "",
			emailId: "",
			page_value: false,
			one_page: {
				// 分页
				currentPageIndex: 1, //当前第几页
				totals: 0, //总共多少条数据
				pageSize: 10, //一页显示几个
			},
			rowItem:{},
			emailRowItem:{},
			szTypeList: [
				{
					id: 1,
					title: "基本设置",
					icon: "",
					icon1: "",
					href: "basicSet",
					name: "basicSet",
				},
				{
					id: 2,
					title: "提交后显示",
					icon: "",
					icon1: "",
					href: "submitSet",
					name: "submitSet",
				},
				{
					id: 3,
					title: "微信设置",
					icon: "",
					icon1: "",
					href: "wxSet",
					name: "wxSet",
				},
				{
					id: 4,
					title: "答题限制",
					icon: "",
					icon1: "",
					href: "answerSet",
					name: "answerSet",
				},
				{
					id: 5,
					title: "题目设置",
					icon: "",
					icon1: "",
					href: "topicsSet",
					name: "topicsSet",
				},
				{
					id: 6,
					title: "答题页显示设置",
					icon: "",
					icon1: "",
					href: "isShowSet",
					name: "isShowSet",
				},
				// {
				// 	id: 7,
				// 	title: "分享设置",
				// 	icon: "",
				// 	icon1: "",
				// 	href: "shareSet",
				// 	name: "shareSet",
				// },
				{
					id: 8,
					title: "防作弊设置",
					icon: "",
					icon1: "",
					href: "antiCheatingSet",
					name: "antiCheatingSet",
				},
			],
		};
	},
	computed: {
    	...mapState(['headers']),
	},
	created() {
		if(sessionStorage.getItem("examId")){
			this.id = sessionStorage.getItem("examId")
			this.accessPermission();
		} else {
			this.$router.replace({
				path: '/myExam'
			});
		}
	},
	mounted() {
		var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
		this.height = winHeight - 108;
		this.rightheight = winHeight - 60;
		window.onresize = () => {
			var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
			this.height = winHeight - 108;
			this.rightheight = winHeight - 60;
		};
		// 分享链接地址
		// this.share.address = `${location.protocol+'//' + location.host}/#/userAnswerPC?id=${sessionStorage.getItem('examId')}`
	},
	methods: {
		accessPermission() {
			let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
			// console.log(userInfo.permissionList);
			let arr = userInfo.permissionList;
			let permissionList = {};
			arr.forEach((item, index) => {
				permissionList['admin' + item] = item;
			});
			console.log(permissionList);
			this.permissionList = permissionList;
			this.navList.forEach(item=>{
				// 分析链接
				if(permissionList.admin1020){
					if(item.id == 0){
						item.show = true
					}
				}else{
					if(item.id == 0){
						item.show = false
					}
				}
				// 设置
				if(permissionList.admin1019){
					if(item.id == 3){
						item.show = true
					}
				}else{
					if(item.id == 3){
						item.show = false
					}
				}
		
			})
			
		},
		// 滚动
		goAnchor(aname) {
		let selector = `a[name=${aname}]`;
		var anchor = this.$el.querySelector(selector); //获取元素
		if (anchor) {
			// start
			anchor.scrollIntoView({ block: "center", behavior: "smooth" });
			// anchor.scrollIntoView();
		}
		},
		// 获取微信分享卡片需要的内容
		getWXshare(data) {
			// console.log(data)
			this.wxshareContent = data.wxShareContent
			this.wxsharePicture = data.wxSharePicture ? data.wxSharePicture : this.$logo
			this.title = data.title
			if (data.wxShareTitle) {
				this.wxshareTitle = this.$functions.htmlFormat(data.wxShareTitle)
			} else {
				this.wxshareTitle = this.$functions.htmlFormat(this.title)
				this.shareTitle(1)
			}
		},
		
		// 获取分享链接 生成二维码
		getShareUrl() {
			let that = this
			let params = {
				that: this,
				url: `${this.$config.service.examRear}?id=${this.id}`,
				method: "GET",
				cb(res) {
					console.log(res)
					if(res.code == '0') {
						that.share.address = res.message
						that.$nextTick(() =>{
							QrCode.toCanvas(that.$refs.qrCodeImg, that.share.address,{
								width: 100,
								height:100
							})
						})
					}
				},
			};
			this.$util.request(params)
		},
		async getExamState(state) {
			this.examState = state
			sessionStorage.setItem("state", state)
			await this.getShareUrl()
		},
		selectIcon(index) {
			this.sendType = index
			console.log(this.sendType)
			if(this.examState == 2 && this.sendType == 0) {
				this.$nextTick(() =>{
					// console.log(this.$refs.qrCodeImg)
					QrCode.toCanvas(this.$refs.qrCodeImg, this.share.address,{
						width: 100,
						height:100
					})
				})
			}
		},
		// 考试发布
		publishwj() {
            console.log('发布') 
			this.$confirm(`确定要发布【${this.$functions.filterHtmlTag(this.title)}】问卷吗?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
				}).then(() => {
					let data = qs.stringify({
						'id': this.id,
						'state': 2
					})
					let that = this
					let params = {
						that: this,
						url: `${this.$config.service.examProjectEditState}?${data}`,
						method: "POST",
						cb(res) {
							console.log(res)
							if(res.code == '0') {
								sessionStorage.setItem("state", 2)
								that.$message.success('发布成功')
								that.$refs.getSetting.getData()
							} else {
								that.$message.warning('请完善考试')
							}
						},
					};
					this.$util.request(params)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消发布'
					});          
			});
			
        },
		// 复制链接
		copyUrl() {
			var copyurl = document.getElementById("copyurl");
			copyurl.select();
			this.$message.success("复制成功！");
		},
		// 打开链接
		openwj() {
			window.open(this.share.address)
		},
		// 下载二维码
		qrCodeUpload() {
			console.log('下载二维码')
			let id = this.id;
			
			
			let can = this.$refs.qrCodeImg
			let cxt = can.getContext("2d")
			let url = can.toDataURL("image/png");
			let arr = url.split(","),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			// 通过以下方式将以上变量生成文件对象，三个参数分别为文件内容、文件名、文件类型
			var file = new File([u8arr], this.title, { type: mime });
			var aDom = document.createElement("a"); // 创建一个 a 标签
			aDom.download = file.name; // 设置文件名
			let href = URL.createObjectURL(file); // 将file对象转成 UTF-16 字符串
			aDom.href = href; // 放入href
			document.body.appendChild(aDom); // 将a标签插入 body
			aDom.click(); // 触发 a 标签的点击
			document.body.removeChild(aDom); // 移除刚才插入的 a 标签
			URL.revokeObjectURL(href); // 释放刚才生成的 UTF-16 字符串
		},
		// 上传图片成功
		handleSuccess(info) {
			let that = this;
			let params = {
				that: this,
				url: that.$config.service.examWxLogoInstall,
				data: {
					surveyId: that.id,
					wxSharePicture: info.message,
				},
				method: "POST",
				cb(res) {
				if (res.code == '0') {
					that.uploadSuces = info.message
					that.logo = false;
					that.logoSucc = true;
					that.btnUpload = false;
					that.btnDel = true;
					// console.log("图片上传成功", res);
				}
				},
			};
			this.$util.request(params);
		},
		// 上传图片之前
		beforeAvatarUpload(file) {
			this.QiniuData.data = file;
		},
		// 清除图片
		handleRemove() {
		this.uploadPicUrl = "";
		},
		// 删除图片
		delImg() {
			console.log('删除图片')
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				url: that.$config.service.delWXSharePicture,
				data: {
				id: id,
				},
				method: "POST",
				cb(res) {
				if (res.code == 0) {
					that.logo = true;
					that.logoSucc = false;
					that.btnUpload = true;
					that.btnDel = false;
					console.log("图片删除成功", res);
				}
				},
			};
			this.$util.request(params);
		},
		//设置微信分享——标题
		shareTitle(state) {
			let that = this
			let params = {
				that: this,
				url: that.$config.service.examWxLogoInstall,
				data: {
					surveyId: that.id,
					wxShareTitle: that.wxshareTitle,
				},
				method: "POST",
				cb(res) {
				if(res.code == '0') {
					if (!state) {
						that.$message.success(res.message)
					}
				} else {
					that.$message.error('修改失败')
				}
				},
			};
			that.$util.request(params);
		},
		//设置微信分享——描述
		shareDesc() {
			let that = this
			let params = {
				that: this,
				url: that.$config.service.examWxLogoInstall,
				data: {
					surveyId: that.id,
					wxShareContent: that.wxshareContent,
				},
				method: "POST",
				cb(res) {
				if(res.code == '0') {
					that.$message.success(res.message)
				} else {
					that.$message.error('修改失败')
				}
				},
			};
			that.$util.request(params);
		},
		// 查看已发送短信
		viewShareMessage() {
			console.log('查看已发送短信')
			this.messageShare = false;
			this.viewEmail = false;
			this.viewEmailDetail = false;
			this.viewShare = true;
			// let that = this;
			// let id = that.wid;
			// let params = {
			// 	that: this,
			// 	url: `${this.$config.service.questionsSms}`,
			// 	method: "POST",
			// 	data: {
			// 	id: id,
			// 	},
			// 	cb(res) {
			// 	if (res.code == 0) {
			// 		console.log(res, "短信获取成功");
			// 		that.beensent = res.resultBody.datas;
			// 		console.log("短信分享", that.beensent);
			// 	}
			// 	},
			// };
			// this.$util.request(params);
		},
		// 跳转联系人
		setContact() {
			// this.$router.push("/contant");
		},
		// 模糊搜索
		searchInput() {
			console.log('模糊搜索短信联系人')
			let array = this.array;
			let input2 = this.input2;
			// let params = {
			// 	that: this,
			// 	url: `${that.$config.service.searchContacts}`,
			// 	data: {
			// 	search: input2,
			// 	},
			// 	method: "POST",
			// 	cb(res) {
			// 	if (res.code == 0) {
			// 		that.searchTell = res.resultBody.datas;
			// 	}
			// 	},
			// };
			// this.$util.request(params);
		},
		// 左侧的添加按钮 原本的是arr11数组 改成了array 11.22
		addright(data) {
			let reg = /^(13[0-9]|14[0-9]|15[0-9]|166|17[0-9]|18[0-9]|19[8|9])\d{8}$/;
			data.text_error = reg.test(data.cellphone);
			if (data.contacts) {
				for (let i = 0; i < data.contacts.length; i++) {
				console.log(data.contacts[i]);
				data.contacts[i].text_error = reg.test(data.contacts[i].cellphone);
				this.array.push(data.contacts[i]);
				}
			} else {
				this.array.push(data);
			}
			this.array = this.unique(this.array)
			this.lenth = this.array.length
			
			console.log("111", this.array)
		},
		treeBox2_a(index) {
			// console.log(index);
			// let that = this;
			// var treephone = {};
			// let reg = /^(13[0-9]|14[0-9]|15[0-9]|166|17[0-9]|18[0-9]|19[8|9])\d{8}$/;
			// treephone.text_error = reg.test(that.searchTell[index].cellphone);
			// treephone.cellphone = that.searchTell[index].cellphone;
			// treephone.name = that.searchTell[index].name;
			// that.array.push(treephone);
			// console.log("that.array", that.array);
			// // that.array = that.unique(that.array);
			// that.lenth = that.array.length;
		},
		// 全删联系人
		delContact() {
			// let that = this;
			// let array = that.array;
			// for (let i = 0; i < array.length; i++) {
			// 	array.splice(i);
			// }
			// that.lenth = this.array.length;
		},
		// 单删除联系人
		delMailConlxr(index) {
			// console.log(index);
			if (index > -1) {
				this.array.splice(index, 1);
			}
			this.lenth = this.array.length;
		},
		// div 富媒体 短信
		addMailCon() {
			console.log('手动输入联系人')
			// 获取之前输入的文本
			let currentPhone = document
				.querySelector("#MailCon_srk")
				.innerText.replace("，", ",");
			console.log("currentPhone", currentPhone.replace("，", ","));
			let currentPhones = currentPhone.replace(/[\r\n]/g, "").split(",");

			let reg = /^[1-9]\d{10}$/; //验证是否为手机号
			let testSpace = /^[ ]*$/g; //验证是否全都为空格
			if (testSpace.test(currentPhones[0])) {
				return false;
			} else {
				console.log("不是空格");
				if (reg.test(currentPhones[0])) {
				this.text_error = false;
				} else {
				this.text_error = true;
				}
			}
			document.querySelector("#MailCon_srk").innerText = "";
			var tempphone = {};
			tempphone.cellphone = currentPhones[0];
			tempphone.name = currentPhones.length >= 2 ? currentPhones[1] : "";
			tempphone.text_error = reg.test(currentPhones[0]);
			this.array.push(tempphone);
			this.lenth = this.array.length;
			console.log("创建的联系人", this.lenth);
			console.log("创建的联系人", this.array);
		},
		ifSelected() {
			if (event.target.check == true) {
				this.ifSel = 0;
			} else {
				this.ifSel = 1;
			}
		},
		saveGroup(value) {
			console.log("value", value);
		},
		//下一步
		xiaPart() {
			let det = [];
			for (let i = 0; i < this.array.length; i++) {
				if (this.array[i].text_error == true) {
				let tempobj = {};
				tempobj.cellphone = this.array[i].cellphone;
				tempobj.name = this.array[i].name;
				tempobj.userId = this.array[i].id;
				det.push(tempobj);
				}
			}
			if (det.length <= 0) {
				this.$message.error("您无可发送的联系人");
				return;
			}

			let that = this;
			this.loading = this.$loading({
				lock: true,
				text: "请稍后",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.7)",
			});
			console.log("下一步", det);
			this.loading.close();
			this.active = 1
			// if (this.active++ > 2) this.active = 0;
			// let id = that.wid;
			// console.log("id", id);
			// let params = {
			// 	that: this,
			// 	url: `${this.$config.service.addquestionssms}`,
			// 	method: "POST",
			// 	data: {
			// 	ifSave: that.ifSel,
			// 	questionsId: id,
			// 	saveGroup: that.label,
			// 	smsContactsList: det,
			// 	},
			// 	cb(res) {
				// that.loading.close();
			// 	if (res.code == 0) {
			// 		console.log(res, "下一步成功");
					// that.sub = res.resultBody;
					// that.active = 1
					// if (that.active++ > 2) this.active = 0;
			// 	}
			// 	},
			// };
			// this.$util.request(params);
			console.log(this.active)
		},
		backSteps() {
			this.active = 0;
		},
		// 发送打开模态框按钮
		achieve() {
			let that = this;
			if(that.sub.smsContent.indexOf('$[surveylink]') == -1){
				that.dialogWJVisible = true
				return false
			}
			that.sendMask = true; //打开模态框
			// that.loading = that.$loading({
			// 	lock: true,
			// 	text: "请稍后",
			// 	spinner: "el-icon-loading",
			// 	background: "rgba(0, 0, 0, 0.7)",
			// });
			// let params = {
			// 	that: this,
			// 	url: `${this.$config.service.querySmsNumber}?type=sms`,
			// 	method: "GET",
			// 	data: {},
			// 	cb(res) {
			// 	that.loading.close();
			// 	if (res.code == 0) {
			// 		// 短信余额
			// 		that.smsBalance = res.resultBody;
			// 		// 字符长度
			// 		that.sub.wordLength = that.getStringWidth(that.sub.smsContent);
			// 		// 消耗的短信条数
			// 		let num = Math.ceil(that.sub.wordLength / 67);

			// 		that.sub.number = num;
			// 		console.log(that.sub.number);
			// 	}
			// 	},
			// };
			// this.$util.request(params);
		},
		accomplish() {
			this.publicPage = true;
			this.messageShare = false;
			this.active = 0;
		},
		// 关闭模态框
		clockSendMask() {
			this.sendMask = false
		},
		sendMask_send() {
			let that = this;
			console.log(that.sub.number);
			if (that.smsBalance < that.sub.number) {
				that.$message.error("短信余额不足,请及时充值");
				return;
			}
			// let params = {
			// 	that: this,
			// 	url: `${this.$config.service.auditSucceed}`,
			// 	method: "POST",
			// 	data: {
			// 	id: that.sub.id,
			// 	number: that.sub.number,
			// 	content: that.sub.smsContent,
			// 	},
			// 	cb(res) {
			// 		if (res.code == 0) {
			// 			console.log(res.resultBody);
			// 			that.active = 2;
			// 			that.smsBalance = that.smsBalance - that.sub.number;
			// 			if (that.smsBalance == 0) {
			// 			that.smsBalance = 0;
			// 			}
			// 			that.$message.success("发送成功");
			// 			that.sendMask = false;
			// 		} else {
			// 			that.$message.error(res.message);
			// 		}
			// 	},
			// };
			// this.$util.request(params);
		},
		// 表格分页
		currentChange(val) {
			this.one_page.currentPageIndex = val;
			this.seeDetail(that.rowItem,val,10)
		},
		seeDetail(row,pageIndex,pageSize) {
			console.log("row", row);
			this.rowItem = row
			this.viewShare = false;
			this.viewDetail = true;
			// let that = this;
			// let params = {
			// 	that: this,
			// 	url: `${this.$config.service.queryQuestionsSmsSendDetails}?id=${row.id}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
			// 	method: "get",
			// 	// data: {
			// 	//   id: id,
			// 	// },
			// 	cb(res) {
			// 	if (res.code == 0) {
			// 		that.SmsContacts = res.resultBody.datas;
			// 		console.log("短信分享", that.SmsContacts);
			// 		that.one_page.currentPageIndex = res.resultBody.pageIndex;
			// 		that.one_page.pageSize = res.resultBody.pageSize;
			// 		that.one_page.totals = res.resultBody.total;
			// 	}
			// 	},
			// };
			// this.$util.request(params);
		},
		// 邮件
		// 查看已分享邮件
		viewShareEmail() {
			this.emailShare = false;
			this.viewEmail = true;
			// let that = this;
			// let id = that.wid;
			// let params = {
			// 	that: this,
			// 	url: `${this.$config.service.queryAllEmail}`,
			// 	method: "POST",
			// 	data: {
			// 	id: id,
			// 	},
			// 	cb(res) {
			// 	if (res.code == 0) {
			// 		console.log(res, "邮件获取成功");
			// 		that.Messagesent = res.resultBody.datas;
			// 	}
			// 	},
			// };
			// this.$util.request(params);
		},
		// 模糊搜索邮件
		searchInput2() {
			let that = this;
			let array = that.array;
			let input2 = that.input2;
			// let params = {
			// 	that: that,
			// 	url: `${that.$config.service.searchContacts}`,
			// 	data: {
			// 	search: input2,
			// 	},
			// 	method: "POST",
			// 	cb(res) {
			// 	// that.loading.close();
			// 	if (res.code == 0) {
			// 		that.searchTell = res.resultBody.datas;
			// 	}
			// 	},
			// };
			// that.$util.request(params);
		},
		//搜索出来的联系人添加到右侧
		treeBox2_b(index) {
			//邮件
			let that = this;
			var treeemail = {};
			var reg = /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
			treeemail.Email_error = reg.test(that.searchTell[index].email);
			treeemail.email = that.searchTell[index].email;
			treeemail.name = that.searchTell[index].name;
			that.arrEmail.push(treeemail);
			// that.arrEmail = that.unique(that.arrEmail);
			that.lenEmail = that.arrEmail.length;
		},
		addEmail(data) {
			console.log("邮件联系人分享", data);
			let that = this;
			let array = that.array;
			var reg = /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;

			data.Email_error = reg.test(data.email);
			if (data.contacts) {
				for (let i = 0; i < data.contacts.length; i++) {
				// console.log(data.contacts[i]);
				data.contacts[i].Email_error = reg.test(data.contacts[i].email);
				this.arrEmail.push(data.contacts[i]);
				}
			} else {
				// console.log(data);
				this.arrEmail.push(data);
			}

			this.arrEmail = this.unique(this.arrEmail);

			this.lenEmail = this.arrEmail.length;
		},
		// 邮件全删联系人
		delEmailContact() {
			let that = this;
			let arrEmail = that.arrEmail;
			for (let i = 0; i < arrEmail.length; i++) {
				arrEmail.splice(i);
			}
			that.lenEmail = this.arrEmail.length;
		},
		// 邮件单删联系人
		delEmailConlxr(index) {
			let that = this;
			let arrEmail = that.arrEmail;
			if (index > -1) {
				arrEmail.splice(index, 1);
			}
			that.lenEmail = this.arrEmail.length;
		},
		// 邮件富媒体联系人
		addemailContacts() {
			console.log(this.arrEmail);
			let that = this;
			let currentEmail = document
				.querySelector("#emailContact")
				.innerText.replace("，", ",");
			let currentEmails = currentEmail.replace(/[\r\n]/g, "").split(",");
			var reg = /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
			console.log(currentEmails);
			if (reg.test(currentEmails[0])) {
				that.Email_error = true;
			} else {
				that.Email_error = false;
			}
			document.querySelector("#emailContact").innerText = "";
			var EmailList = {};
			EmailList.email = currentEmails[0];
			EmailList.name = currentEmails.length >= 2 ? currentEmails[1] : "";
			EmailList.Email_error = reg.test(currentEmails[0]);
			that.arrEmail.push(EmailList);
			that.lenEmail = that.arrEmail.length;
			console.log("创建的联系人", that.arrEmail);
		},
		// 邮件下一步
		nextStept() {
			let emData = [];
			for (let i = 0; i < this.arrEmail.length; i++) {
				emData.push({cellphone: this.arrEmail[i].cellphone,email:this.arrEmail[i].email,name:this.arrEmail[i].name,iserId:this.arrEmail[i].id});
				console.log(this.arrEmail[i])
			}
			if (emData.length) {
				let that = this;
				let id = that.wid;
				that.ativeStep = 1;
				// let params = {
				// that: this,
				// url: `${this.$config.service.addQuestionsEmail}`,
				// method: "POST",
				// data: {
				// 	ifSave: that.ifSel,
				// 	questionsId: id,
				// 	saveGroup: that.labelEm,
				// 	smsContactsList: [
				// 	...emData
				// 	],
				// },
				// cb(res) {
				// 	if (res.code == 0) {
				// 	console.log("下一步成功", res);
				// 	// that.sub = res.resultBody
				// 	that.emailId = res.resultBody.id;
				// 	that.contentt = res.resultBody.emailContent;
				// 	that.theme = res.resultBody.questionsName;
				// 	// that.ativeStep = 1;
				// 	if (that.ativeStep++ > 2) this.ativeStep = 0;
				// 	}
				// },
				// };
				// this.$util.request(params);
			} else {
				this.$message.error("您无可发送的联系人");
				return;
			}
		},
		// 邮件下一步
		emailNextStept() {
			console.log('下')
			let that = this;
			if (that.theme != "") {
				if(that.contentt.indexOf('$[surveylink]') == -1){
				that.dialogWJVisible = true
				return false
				}
				that.ativeStep = 2
				// that.loading = that.$loading({
				// lock: true,
				// text: "请稍后",
				// spinner: "el-icon-loading",
				// background: "rgba(0, 0, 0, 0.7)",
				// });
				// let params = {
				// that: this,
				// url: `${this.$config.service.querySmsNumber}?type=email`,
				// method: "GET",
				// data: {},
				// cb(res) {
				// 	that.loading.close();
				// 	if (res.code == 0) {
				// 	that.emailBalance = res.resultBody;
				// 	that.sendEmailContent = tinyMCE.activeEditor.getContent();
					// if (that.ativeStep++ > 2) that.ativeStep = 0;
				// 	}
				// },
				// };
				// this.$util.request(params);
			} else {
				that.$message.error("请填写邮件主题！");
			}
		},
		lastStep() {
			console.log("上一步");
			let that = this;
			if (that.ativeStep-- < 2) this.ativeStep = 0;
		},
		// 发送邮件
		sendEmails() {
			if(this.emailBalance){
				let that = this;
				let params = {
				that: this,
				url: `${this.$config.service.sendEmail}`,
				method: "POST",
				data: {
					addresser: "东方艾学",
					addresserEmail: "ai@almail.ai-learning.com.cn",
					emailContent: that.sendEmailContent,
					id: that.emailId,
					sendState: 0,
					title: that.theme,
				},
				cb(res) {
					if (res.code == 0) {
					console.log(res);
					that.$message.success(res.message);
					if (that.ativeStep++ > 2) that.ativeStep = 0;
					}
				},
				};
				this.$util.request(params);
			} else {
				this.$message.warning('邮件余额不足，请充值购买！')
			}
		},
		accomplishEmail() {
			this.publicPage = true;
			this.emailShare = false;
			this.ativeStep = 0;
		},
		emailCurrentChange(val){
			let that = this;
			that.one_page.currentPageIndex = val;
			that.seeDetailEmail(that.emailRowItem,val,10)
		}
	}
};
</script>

<style scoped lang="scss">
.setUp-box{
	margin-left: 280px;

}
.typesetting{
	margin: auto;
}
@media (min-width: 768px) {
  .typesetting {
    width: 600px;
    margin-top: 2px;
  }
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media (min-width: 992px) {
  .typesetting {
    width: 700px;
    margin-top: 2px;
  }
}
/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: 1452px) {
  .typesetting {
    width: 800px;
    margin-top: 2px;
  }
}
.content-box{
	margin-left: 80px;
    min-height: calc(100vh - 60px);
    background-color: #f3f5f6;
}
.unpublished{
	// width: calc(100vw - 510px);
	height: calc(100vh - 62px);
	margin-top: 2px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	// background-color: #fff;
}
// .setUp-box{
// 	width: 430px;
//     position: fixed;
//     right: 0;
// 	height: calc(100vh - 62px);
// 	overflow-y: scroll;
// }
// .setUp-box::-webkit-scrollbar{
//     display: none;
// }
.box-card {
  padding-top: 20px;
}
.activebox div i {
	color: #0080ff !important;
}
.activebox p {
	color: #0080ff;
}
.wjstate {
	width: 100%;
	display: flex;
	margin-top: 60px;
}
.leftNav {
	width: 80px;
	height: calc(100vh - 62px);
	background: #ffffff;
	position: fixed;
	border-right: 2px solid #ccc;
}
.leftNav div li {
	list-style: none;
}
.textStyle {
	font-size: 14px;
	color: #333;
}
.boxbox {
	margin: 0 auto;
	width: 60px;
	margin-top: 18px;
}
.iconStyleBox {
	width: 50px;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.rightNav {
	width: 100%;
	height: auto;
}

.wjTypeChild {
	width: 80px;
	background-color: #fff;
	padding-top: 15px;
	padding-bottom: 30px;
	float: left;
	display: inline;
  .wjTypeChildItemFont {
    font-size: 14px;
    cursor: pointer;
    .icon {
      margin: 0px auto;
      width: 50px;
      height: 50px;
      border-radius: 5px;
      img{
        margin-top: 12px;
      }
    }
  }
  .wjTypeChildItem {
    text-align: center;
    margin-top: 40px;
  }
  .iconActive {
    color: #0080ff;
  }

  .iconActive > .icon {
    background-color: #0080ff;
  }
}
.share_project {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #333;
}
.share_project span {
  font-family: MicrosoftYaHei;
  font-size: 12px;
  color: #666;
  margin-left: 10px;
}
.share-contont {
  width: 800px;
  height: 190px;
  background: #fff;
  box-shadow: 2px 2px 5px #ccc;
  border-radius: 3px;
  margin-top: 17px;
  display: flex;
  align-items: center;
}
.sendData h3 i {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 0px;
  right: 25px;
}
.sendData h3 {
  color: #353535;
  font-size: 16px;
  font-weight: bold;
  padding-left: 25px;
  border-bottom: #eeeff1 solid 1px;
  position: relative;
  height: 30px;
}
/* 遮罩层 */
.sendMask {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.3;
}
/* 短信确认发送遮罩层 */
.sendData {
  position: fixed;
  background: #fff;
  width: 600px;
  min-height: 350px;
  overflow: auto;
  opacity: 1;
  z-index: 2001;
  top: 30%; /*偏移*/
  left: 50%;
  margin-left: -300px;
  border-radius: 5px;
}

.emali_fs p {
  padding: 20px 0px 0px 20px;
  font-size: 14px;
}
.emaileAuccess {
  width: 90px;
  height: 38px;
  margin-left: 400px;
  border: none;
  background: #0080ff;
  color: #fff;
  border-radius: 3px;
  margin-top: 30px;
  margin-bottom: 40px;
}
.justifyCenter {
  text-align: center;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 32px;
  letter-spacing: 0px;
  color: #333333;
  margin-top: 15px;
}
/deep/.sendSelect .el-input__inner {
  width: 140px !important;
  height: 30px !important;
}
.custom-tree-node {
  width: 254px;
  position: relative;
}
.custom-tree-node i {
  color: #0080ff;
  position: absolute;
  right: 15px;
  top: 3px;
}

/*搜索手机号出来的div*/
.treeBox2 {
  padding: 5px;
}
.treeBox2:hover {
  background: #c5e8fe;
}
.treeBox2_a {
  padding: 1px;
  display: block;
  color: #666;
}
.searchInput {
  width: 243px;
  margin: 17px auto;
}
.delContact i {
  margin-right: 15px;
  color: #0080ff;
}
.delContact span {
  margin-left: 15px;
  font-size: 14px;
  color: #333;
}
.delContact {
  width: 646px;
  height: 43px;
  display: flex;
  background: #f5f5f5;
  justify-content: space-between;
  align-items: center;
}
.accomplishPage div button {
  width: 90px;
  height: 38px;
  margin-left: 435px;
  margin-top: 30px;
  margin-bottom: 30px;
  background: #0080ff;
  color: #fff;
  border: none;
  border-radius: 3px;
}
.accomploshText p {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #333333;
  text-align: center;
}
.accomplishPage {
  width: 920px;
  display: flex;
  flex-direction: column;
}
.success_btn {
  width: 926px;
  height: 38px;
  margin-top: 19px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 40px;
}
.success_btn span {
  font-size: 14px;
  color: #0080ff;
}
.success_btn div button {
  width: 90px;
  height: 38px;
  text-align: center;
  line-height: 38px;
  font-size: 16px;
  border: none;
  border-radius: 3px;
}
.sendContent {
  width: 926px;
  height: 343px;
  border: 1px solid #ccc;
  padding-top: 38px;
  padding-left: 25px;
}
.surveylink {
  width: 502px;
  height: 165px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 28px;
  letter-spacing: 0px;
  color: #666666;
  margin-top: 55px;
}
.setContact {
  width: 254px;
  height: 43px;
  background-color: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.setContact span {
  margin-left: 15px;
  font-size: 14px;
  color: #333;
}
.setContact i {
  color: #0080ff;
  margin-right: 20px;
}
.Manually_enter_contacts {
  width: 646px;
  height: 518px;
  border: 1px solid #ccc;
  overflow: auto;
}
/*div富媒体 短信*/
#MailCon {
  outline: none;
}
.MailCon_srk {
  /* 取消点击框*/
  outline: none;
  height: calc(520px - 70px);
  padding: 10px 20px;
}
#MailCon_lxr:hover {
  background: #e6eaf0;
}
/*邮箱*/
#emailContact {
  outline: none;
}
.emailContact {
  outline: none;
  height: calc(520px - 70px);
  padding: 10px 20px;
}
/*手机号错误*/
.text_error {
  color: red !important;
}
.Email_error {
  color: red !important;
}

.contact_list {
  width: 254px;
  height: 518px;
  border: 1px solid #cccccc;
}
.Contact_table {
  display: flex;
  justify-content: space-between;
}
.brief_introduction {
  font-size: 14px;
  color: #666;
  margin-top: 35px;
  margin-bottom: 23px;
}
.stepsbg {
  width: 1000px;
  background: #fff;
  height: auto;
  box-shadow: 2px 2px 5px #ccc;
  border-radius: 3px;
}
.view_share {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #0080ff;
}
.message_text {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #333333;
}
.message_title {
  width: 1000px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.link-box{
	// width: 1000px;
	// margin: auto;
	margin-left: 80px;
}
.share-box {
	// width: calc(100vw - 510px);
    width: max-content;
	margin: auto;
}
.message_share {
  width: 1000px;
//   height: auto;
//   margin: auto;
  margin-top: 10px;
}
.tabPaneBox {
  width: 752px;
  margin-left: 24px;
}
/deep/.el-tabs__item {
  font-size: 16px !important;
  width: 105px !important;
}
/deep/.el-tabs__nav {
  width: 800px !important;
  height: 56px !important;
  line-height: 60px !important;
  margin-left: 24px;
}
.websites_content {
  width: 800px;
  height: 430px;
  background: #fff;
  box-shadow: 2px 2px 5px #ccc;
  border-radius: 3px;
  margin-top: 15px;
  margin-bottom: 34px;
}
.custom_text_box {
  width: 800px;
  border-bottom: 1px solid #e3e3e8;
  display: flex;
  justify-content: center;
}
.custom_text {
  width: 740px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.custom_content {
  width: 800px;
  height: 98px;
  background: #fff;
  box-shadow: 2px 2px 5px #ccc;
  border-radius: 3px;
  margin-top: 15px;
  margin-bottom: 34px;
}
.wjInfo_img {
  width: 40px;
  height: 40px;
  margin-top: 56px;
}
.wjInfo_content {
  width: 193px;
  height: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 12px;
  margin-top: 10px;
}
.arrow_text_part {
  width: 193px;
  height: 70px;
  margin-top: 15px;
  margin-left: 15px;
}
.arrow_content_box {
  width: 260px;
  position: absolute;
  top: 0;
  left: 0;
//   z-index: 999;
  display: flex;
  justify-content: center;
}
.send {
  position: relative;
  width: 276px;
  height: 97px;
  background: #fff;
  border-radius: 5px; /* 圆角 */
  border: 1px solid #ccc;
  margin-top: 16px;
}
.send .arrow {
  width: 6px;
  height: 6px;
  background: #fff;
  z-index: 1;
  top: 11px;
  right: -4px;
  position: absolute;
  border-top: 1px solid #d8d8d8;
  border-right: 1px solid #d8d8d8;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.share_description {
  margin-top: 24px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #333333;
}
.btnDel {
  width: 88px;
  height: 34px;
  background: #fff;
  border-radius: 3px;
  border: 1px solid #ccc;
  color: #0080ff;
}
.upload_preview {
  width: 376px;
  height: 399px;
  background: #f7f8fa;
  display: flex;
  justify-content: center;
}
.upload_explain {
  width: 356px;
  height: 399px;
}
.wx_content {
  width: 800px;
  height: 439px;
  background: #fff;
  box-shadow: 2px 2px 5px #ccc;
  margin-top: 16px;
  margin-bottom: 34px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.qrCode {
  width: 151px;
  height: 120px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 15px;
}
.qrCode-img{
	margin-bottom: 10px;
}
.link_line-box{
	margin-top: 11px;
    display: flex;
	.btn{
		margin-left: 10px;
	}
}
/deep/ .link_line .el-input {
  width: 356px;
  height: 36px;
}
/deep/.link_line .el-input__inner {
  width: 280px;
  height: 36px;
}
/deep/.link_line .el-button {
  width: 76px !important;
  height: 36px;
  border: none;
  background: #409EFF;
  color: #fff;
  border-radius: 0px 3px 3px 0px;
}
.answer-square{
	margin-top: 20px;
}
.fl_link {
  width: 610px;
  height: 120px;
  border-right: 1px dashed #ccc;
  margin-left: 38px;
}
.Channels_content {
  width: 800px;
  height: 190px;
  background: #fff;
  box-shadow: 2px 2px 5px #ccc;
  border-radius: 3px;
  margin-top: 15px;
  margin-bottom: 34px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
/* 中等屏幕（桌面显示器，大于等于 992px） */
@media (min-width: 1200px) {
  .box-card {
    /* width: calc(800px + 300px); */
    width: 800px;
  }
}
/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (max-width: 1200px) {
  .box-card {
    width: calc(800px + 300px);
  }
}
.share_project {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #333;
}
.share_project span {
  font-family: MicrosoftYaHei;
  font-size: 12px;
  color: #666;
  margin-left: 10px;
}
.wjType {
  width: 360px;
  float: left;
  display: inline;
}

.wjEdit {
  /* display: inline; */
  /* margin-left: 350px; */
  /* width: 900px; */
  /* overflow-y: auto; */
  margin: 0 auto;
  /* margin-top: 61px; */
}

.wjTypeChild {
  width: 80px;
  background-color: #fff;
  padding-top: 15px;
  padding-bottom: 30px;
  float: left;
  display: inline;
}
.display_inline {
  display: inline;
  float: left;
  height: 68px;
  line-height: 68px;
}
.wjTypeChildQuestion {
  margin-left: 2px;
  width: 278px;
  background-color: #fff;
//   padding-top: 15px;
  padding-bottom: 30px;
  float: left;
  display: inline;
  overflow-y: auto;
  position: fixed;
  top: 61px;
  left: 80px;
}
.tk_item {
  width: 260px;
  height: 69px;
  margin: 0px auto;
  border-bottom: 1px #d5d5d6 solid;
}





.center {
  text-align: center;
}



.qtypeTitle {
  padding-left: 15px;
  height: 40px;
  line-height: 40px;
  font-weight: bold;
  font-size: 16px;
}

.qtypeItem {
  text-align: center;
  display: inline;
  float: left;
  width: 80px;
  height: 80px;
  border: 1px solid #eaeaea;
}
.dt-title {
  text-align: center;
  margin-top: 20px;
  font-size: 16px;
}
.tx_box {
  width: 100%;
  min-height: 300px;
  margin-top: 30px;
  padding-bottom: 20px;
  background: #fff;
  box-shadow: 1px 3px 17px -5px #aeaeae;
}
.tj_box li {
  flex: 1;
  height: 100%;
  border-right: 1px solid #ccc;
}
.tj_box li p {
  font-size: 16px;
  color: #333;
  margin-bottom: 20px;
}
.tj_box li span {
  font-size: 20px;
  color: red;
}
.tj_box li:last-child {
  border-right: 0;
}
.tj_box {
  width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 1px 3px 17px -5px #aeaeae;
  margin-top: 30px;
  padding: 20px 0;
}
.title_tj {
  font-size: 18px;
}
.time {
  font-size: 14px;
  color: #666;
}
.display_inline {
  display: inline;
  float: left;
}
.el-header,
.el-footer {
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0px;
}
div_aside {
  width: 100%;
  height: 100%;
}
.el-aside {
  max-width: 300px;
  height: 100%;
  text-align: center;
  line-height: 200px;
  color: #333;
  background-color: rgb(12, 146, 255);
  display: inline;
  position: fixed;
  top: 0px;
  right: 16px;
}
.el-main {
  display: inline;
  background-color: #f3f5f6;
}
body > .el-container {
  margin-bottom: 40px;
}
.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}
.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
.el-collapse-item__header {
  padding-left: 6px !important;
  font-weight: 800 !important;
}
.askitem {
  width: 32%;
  height: 80px;
  margin: 1px;
  cursor: pointer;
}
.type-item-icon {
  height: 50px;
  line-height: 86px;
  text-align: center;
}
.type-item-title {
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 8px;
}
.item_container {
  margin-top: 8px;
  background-color: #fff;
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-top: 6px;
  padding-bottom: 6px;
}
.item_container_hover {
  border: 2px #409eff solid;
  border-radius: 3px;
}
.el-input__inner {
  border-radius: 0;
  padding-left: 5px;
  padding-right: 5px;
}
.el-input__inner:hover {
  background-color: #aaa;
}
.operate_td {
  width: 30px;
  height: 30px;
  font-size: 26px;
  background-color: cornflowerblue;
  text-align: center;
  line-height: 30px;
}
.el-tooltip {
  padding-top: 0px !important;
}
.el-menu-item {
  margin-left: 0px !important;
}
.ck-content {
  min-height: 200px;
}
.el-divider--horizontal {
  margin: 0px !important;
}
.operate_item {
  height: 60px;
  line-height: 60px;
  width: 90%;
  margin: 0px auto;
}
.left {
  float: left;
  margin-left: 6px;
}

.right {
  float: right;
}

/deep/.limit{
  font-size: 16px;
}
/deep/.answer_set_ul {
  font-size: 14px;
}
</style>

<style>
/*进度条样式*/
/*上一个*/
.stepsbg .is-finish {
  color: #409eff !important;
}
/*当前*/
.stepsbg .is-process {
  color: #409eff !important;
  border-color: #409eff !important;
}
/*内条有问题的横杠*/
.stepsbg .el-step__line {
  border-color: #409eff !important;
}

.el-collapse-item__header {
  margin-left: 10px !important;
  font-weight: bold;
}

.el-collapse-item__header {
  margin-left: 13px;
  font-weight: bold;
}

.option_input > input {
  height: 35px !important;
  line-height: 35px !important;
  border: 1px #aaa solid !important;
}

.option_input > input:hover {
  height: 35px !important;
  line-height: 35px !important;
  border: 1px #aaa solid !important;
}



.el-submenu__title {
  text-align: left !important;
}
</style>
